import React, { useState, useEffect } from "react";
import { CBadge, CDataTable } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import { fetchList } from "src/store/actions/admin";
import { defaultLimitPerPage } from "src/utils/constants";
import PageContainer from "src/components/PageContainer";

const type = "orderLogs";

const getLevelBadge = (level) => {
  switch ((level || "").toLowerCase()) {
    case "error":
      return "danger";
    case "warn":
    case "warning":
      return "warning";
    case "info":
      return "success";
    default:
      return "secondary";
  }
};

const OrderLogs = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.admin.orderLogs.loading);
  const orderLogsList = useSelector(
    (state) => state.admin.orderLogs.data.data
  );
  const total = useSelector((state) => state.admin.orderLogs.data.count) || 0;
  const [page, setPage] = useState(1);
  const [limitPerPage, setLimitPerPage] = useState(defaultLimitPerPage);
  const totalpage = Math.ceil(total / limitPerPage) || 1;

  const pageChange = (newPage) => {
    if (newPage !== 0) setPage(newPage);
  };

  useEffect(() => {
    dispatch(
      fetchList(type, {
        skip: (page - 1) * limitPerPage,
        limit: limitPerPage,
        category: ["cart", "order"],
      })
    );
  }, [dispatch, page, limitPerPage]);

  return (
    <PageContainer
      title="Order Logs"
      pagination={{
        activePage: page,
        onActivePageChange: pageChange,
        pages: totalpage,
        setLimitPerPage,
      }}
    >
      <CDataTable
        items={orderLogsList}
        fields={[
          { key: "sr_no", label: "Sr No" },
          { key: "level", label: "Level" },
          // { key: "category", label: "Category" },
          { key: "msg", label: "Message" },
          { key: "time", label: "Time" },
        ]}
        hover
        clickableRows
        responsive
        loading={loading}
        scopedSlots={{
          sr_no: (_, index) => (
            <td>{limitPerPage * (page - 1) + (index + 1)}</td>
          ),
          level: (item) => (
            <td>
              <CBadge color={getLevelBadge(item?.level)}>
                {item?.level
                  ? item.level.charAt(0).toUpperCase() +
                    item.level.slice(1).toLowerCase()
                  : "-"}
              </CBadge>
            </td>
          ),
          // category: (item) => <td>{item?.category || "-"}</td>,
          msg: (item) => (
            <td
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                minWidth: 280,
              }}
            >
              {item?.msg || "-"}
            </td>
          ),
          time: (item) => (
            <td style={{ whiteSpace: "nowrap" }}>
              {item?.time
                ? Moment(item.time).format("DD-MM-YYYY hh:mm a")
                : item?.created_at
                ? Moment(item.created_at).format("DD-MM-YYYY hh:mm a")
                : "-"}
            </td>
          ),
        }}
      />
    </PageContainer>
  );
};

export default OrderLogs;
